(ns frontend.view.nev.kyc.process.file-editor
  (:require-macros [frontend.macros :refer [without-default-action-and-propagation]])
  (:require [basic-components.inputs.footprint :refer [editor viewer]]
            [common.localization :as loc]
            [common.roles :as roles]
            [frontend.state.current-session :as session]
            [frontend.utils :as fu]
            [frontend.view.entity-viewers.modules.attachments :as attachments]
            [frontend.view.modals.delete-confirmation.view :as delete-confirmation-modal]
            [frontend.view.modals.events :as modals]
            [reagent.core :as r]
            [ui.components.button.view :as button]
            [ui.util :as uu]))

(defn render-existing-attachment [{:keys [lang-kw attachment answers-atom local-atom q process-id save!]}]
  [:div.attachments-list-attachment.mt-2
   (when (roles/user? @session/role)
     {:on-click #(fu/open-attachment! (:db/id attachment))})
   [:div.module-attachment-left
    [:i.fal.fa-paperclip.module-attachment-icon]
    [:span.module-attachment-filename (:attachment/filename attachment)]]
   [:div.module-attachment-right
    [:div.module-attachment-buttons
     (when (roles/user? @session/role)
       [button/square-secondary-open
        {:on-click (without-default-action-and-propagation
                    (fu/open-attachment! (:db/id attachment)))}
        [:i.fal.fa-external-link]])
     (when (roles/user? @session/role)
       [button/square-secondary-open
        {:on-click (without-default-action-and-propagation
                    (fu/download-attachment! (:db/id attachment)))}
        [:i.fal.fa-cloud-download]])
     [button/square-secondary-open
      {:on-click (without-default-action-and-propagation
                  (modals/open-modal!
                   delete-confirmation-modal/modal-key
                   {:body       (loc/tr :attachment-delete nil lang-kw)
                    :lang-kw    lang-kw
                    :on-delete! (fn [_]
                                  (swap! answers-atom dissoc q)
                                  (reset! local-atom {})
                                  (attachments/remove-attachment! process-id attachment)
                                  (save!))}))}
      [:i.fal.fa-trash-alt.pointer]]]]])


(defn file-editor [{:keys [process-id lang-kw q m answers-atom mandatory? read-only? save!]}]
  (let [local-atom (r/atom {})]
    (fn [{:keys [process-id lang-kw q m answers-atom mandatory? read-only? save!]}]
      (let [attachment-id (get @answers-atom q)
            attachment (session/get-entity attachment-id)]
        [:div
         [:label
          {:class (uu/cm "input-editor__label pb-2"
                         (when mandatory?
                           "after:ml-0.5 after:text-danger-regular after:content-['*']"))}

          (some-> m :translations (get lang-kw))]
         (when-let [info (some-> m :info (get lang-kw))]
           [viewer {:editor/type :editor.type/wysiwyg
                    :value       info}])
         (cond (and attachment read-only?)
               [:div.preview
                [:a.attachment-read-only
                 {:href     "#"
                  :on-click (without-default-action-and-propagation
                             (fu/download-attachment! (:db/id attachment)))}
                 (:attachment/filename attachment)]]
               attachment
               [render-existing-attachment {:attachment   attachment
                                            :answers-atom answers-atom
                                            :local-atom   local-atom
                                            :read-only?   read-only?
                                            :save!        save!
                                            :q            q
                                            :lang-kw      lang-kw
                                            :process-id   process-id}]
               read-only?
               [:div (loc/tr :file-not-uploaded)]
               :else
               [:div
                (if (:uploading @local-atom)
                  [attachments/indicators local-atom process-id]
                  [attachments/upload-area local-atom process-id
                   (fn [resp]
                     (swap! answers-atom assoc q (:db/id resp))
                     (save!))
                   {:lang-kw lang-kw}])])]))))

